import { createAction } from '@reduxjs/toolkit';

export const deleteFromBreadcrumbs = createAction(
  'breadcrumbs/deleteFromBreadcrumbs'
);
